export const BLUE_CHECK = '#2CB2F1';
export const BORDER_COLOR = '#D0D2D3';
export const BACKGROUND_COLOR_HOVER = '#FFFFFF';
export const BORDER_COLOR_HOVER = '#9DA5AA';
export const RESPONSE_PAGE_SIZE = 20;
export const ALL_FILTER_ID = '-1';
export const ALL_FILTER_ID_BLANK = '-2';
export const INDETERMINATE_FILTER_ID = '-3';
export const ALL_RESPONSES = 'All Responses';
export const MIN_NUMBER_OF_THEMES = 2;
export const PERCENT_TO_TAG = 5;
export const NUMBER_OF_RESPONSES = 5;
export const SIGNIFICANT_CHANGES_FOR_RETRAIN = 10;
export const MAX_SEEN_COUNT_UPDATE_AUTOTAGGING_MODAL = 1;
export const COLD_START_ENABLED = false;
export const USE_CASES = {
  employee_engagement: 'ex',
  customer_satisfaction: 'cx',
  concept_testing: 'ctm',
  none: 'none'
};
export const USE_CASE_NONE = USE_CASES.none;
export const COLD_START_THEMES_TO_SHOW = 10;
export const Z_INDEX = 2000;